/** 我的績效(performance.html)進入點。
 *  圖表為靜態示意資料(RP 規格:此頁先放外觀),僅側欄為動態資料。
 */
import '../loading';
import { initStudentPage } from '../dashboard';

void initStudentPage();
